import { AxiosError } from 'axios';

const DEFAULT_MESSAGE = 'Não foi possível concluir. Tente novamente.';

/**
 * Extrai a mensagem que a API mandou para o cidadão ler.
 *
 * O ValidationPipe do Nest devolve `message` como array quando há vários
 * campos inválidos; o filtro de domínio devolve uma frase só. Os dois casos
 * chegam aqui.
 */
export function messageFromError(error: unknown, fallback = DEFAULT_MESSAGE): string {
  const response = (error as AxiosError<{ message?: string | string[] }>)?.response;

  if (!response) return fallback;

  const { message } = response.data ?? {};

  if (Array.isArray(message)) return message.join(' ');
  if (typeof message === 'string' && message.trim()) return message;

  if (response.status === 401) {
    return 'Sua sessão expirou. Entre novamente pelo portal.';
  }
  if (response.status >= 500) {
    return 'O serviço está indisponível no momento. Tente mais tarde.';
  }

  return fallback;
}
